import { useCallback } from "react";
import { useLocalStorage } from "@uidotdev/usehooks";

export function useDeleteMapState() {
	const [mapStates] = useLocalStorage<{
		[s: string]: unknown;
	}>("mapStates");

	const deleteMapState = useCallback(
		(mapId?: string) => {
			if (!mapId) return;

			const updatedMapStates = { ...mapStates };
			delete updatedMapStates[mapId];

			localStorage.setItem("mapStates", JSON.stringify(updatedMapStates));
		},
		[mapStates]
	);

	return { deleteMapState };
}
